import React, { useEffect } from 'react'

// Components
import TextInput from 'components/input/TextInput'
import MultipleSelectInput from 'components/input/MultipleSelectInput'

// Data
import {
    options,
    disabilities
} from 'utils/constants/data';

function Disability({
    values,
    errors,
    touched,
    setFieldValue,
    handleChange,
    handleBlur,
}) {

    useEffect(() => {
        if (!values.is_having_disability) {
            setFieldValue(`disabilities`, [])
        }
    }, [
        values.is_having_disability
    ]);

    return (
        <div className='bg-white rounded-lg mx-4 px-6 py-4 md:px-10 md:py-8 space-y-4 sm:space-y-6'>
            <p className='uppercase text-xl sm:text-2xl mb-2 md:mb-4 font-bold'>Disability</p>
            <hr className='h-1 border-none text-[#333] bg-[#333]' />
            <p className='uppercase text-lg sm:text-xl xl:text-2xl mb-2 md:mb-4 font-bold'>12. Do you consider yourself to have disability, impairment or long-term condition?</p>
            <div className='flex flex-col space-y-2'>
                {options.map((option, i) => {
                    return (
                        <div className='flex flex-row items-center space-x-3'>
                            <div>
                                <input
                                    checked={values.is_having_disability === option.value}
                                    id={`disability-radio-btn-${i}`}
                                    name={`disability-${i}`}
                                    type="radio"
                                    onChange={() => setFieldValue(`is_having_disability`, option.value)}
                                    value={values.is_having_disability}
                                    className="mt-1 w-4 h-4 md:w-6 md:h-6 text-blue-600 bg-white border-gray-300 peer-checked:bg-sky-600"
                                />
                            </div>
                            <p className='text-base xl:text-lg' key={i}>{option.title}</p>
                        </div>
                    )
                })}
            </div>
            {(errors?.is_having_disability && touched?.is_having_disability) && errors.is_having_disability && (
                <p className='text-xs sm:text-sm xl:text-base text-red-500'>{errors.is_having_disability}</p>
            )}
            {values.is_having_disability === false && (
                <p className='text-sm xl:text-base font-semibold'>If "No" – Go To Question 14.</p>
            )}
            {values.is_having_disability && (
                <div className='space-y-4 sm:space-y-6'>
                    <p className='uppercase text-lg sm:text-xl xl:text-2xl mb-2 md:mb-4 font-bold'>13. If you indicated the presence of a disability, impairment or long-term condition, please select the area(s) in the following list:</p>
                    <p className='text-sm xl:text-base'>If you may indicate more than one area, please refer to the <a className="text-base xl:text-lg underline font-bold" href="/disability-supplement" target="_blank" rel="noopener noreferrer"> Disability Supplement</a> for an explanation of the following disabilities.</p>
                    <MultipleSelectInput
                        name="disabilities"
                        classNameInput="text-base xl:text-lg"
                        label=""
                        options={disabilities}
                        placeholder="Select presence of disabilities..."
                        setFieldValue={setFieldValue}
                        onBlur={handleBlur}
                        error={(errors?.disabilities && touched?.disabilities) && errors.disabilities}
                        value={values.disabilities}
                    />
                </div>
            )}
        </div>
    )
}

export default Disability